import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
import view from '../view/_router'

export default new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        redirect: '/index'
      }, {
        path: '/admin',
        component: resolve => require(['../view/common/Home.vue'], resolve),
        children: view.index
      },
      {
        path: '/login',
        component: resolve => require(['../view/common/login/Login.vue'], resolve)
      },
      {
        path: '/registration',
        component: resolve => require(['../view/common/login/Registration.vue'], resolve)
      },
      {
        path: '*',
        redirect: '/index'
      }
    ]
})



// WEBPACK FOOTER //
// ./src/config/vueRouter.js